module.exports = __webpack_public_path__ + "static/img/14.ddc1b8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/14.png
// module id = 69zj
// module chunks = 0